module.exports = __webpack_public_path__ + "media/4.ad08ff67.mp3";